// extracted by mini-css-extract-plugin
module.exports = {"card":"LoaderSkeleton_card__3x6aw"};